/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetAdyenCredentials200Response,
  GetNexoRequestRequest,
  UpdatePaymentTipRequest,
} from '../models/index';
import {
    GetAdyenCredentials200ResponseFromJSON,
    GetAdyenCredentials200ResponseToJSON,
    GetNexoRequestRequestFromJSON,
    GetNexoRequestRequestToJSON,
    UpdatePaymentTipRequestFromJSON,
    UpdatePaymentTipRequestToJSON,
} from '../models/index';

export interface GetAdyenCredentialsRequest {
    poiid: string;
}

export interface GetNexoRequestOperationRequest {
    getNexoRequestRequest: GetNexoRequestRequest;
}

export interface UpdatePaymentTipOperationRequest {
    updatePaymentTipRequest: UpdatePaymentTipRequest;
}

/**
 * 
 */
export class PaymentsApi extends runtime.BaseAPI {

    /**
     */
    async getAdyenCredentialsRaw(requestParameters: GetAdyenCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAdyenCredentials200Response>> {
        if (requestParameters['poiid'] == null) {
            throw new runtime.RequiredError(
                'poiid',
                'Required parameter "poiid" was null or undefined when calling getAdyenCredentials().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payments/adyen/terminals/{poiid}/credentials`.replace(`{${"poiid"}}`, encodeURIComponent(String(requestParameters['poiid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAdyenCredentials200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAdyenCredentials(requestParameters: GetAdyenCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAdyenCredentials200Response> {
        const response = await this.getAdyenCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNexoRequestRaw(requestParameters: GetNexoRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['getNexoRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'getNexoRequestRequest',
                'Required parameter "getNexoRequestRequest" was null or undefined when calling getNexoRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/payments/nexo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetNexoRequestRequestToJSON(requestParameters['getNexoRequestRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getNexoRequest(requestParameters: GetNexoRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getNexoRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updatePaymentTipRaw(requestParameters: UpdatePaymentTipOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updatePaymentTipRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePaymentTipRequest',
                'Required parameter "updatePaymentTipRequest" was null or undefined when calling updatePaymentTip().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/payments/updatePaymentTip`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePaymentTipRequestToJSON(requestParameters['updatePaymentTipRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePaymentTip(requestParameters: UpdatePaymentTipOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePaymentTipRaw(requestParameters, initOverrides);
    }

}
